export default __webpack_public_path__ + "static/media/mother-wound-cover.22456c14.jpeg";